import React from "react";
import { useTranslation } from "react-i18next";

const Tip = () => {

  const { t } = useTranslation();

  return (
    <div className="tutorial_notes">
      <div className="area_view">
        <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_01.svg`} alt="" />
        <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_mo_note1-1.svg`} alt="" />
        <p className="tutor_txt" dangerouslySetInnerHTML={{ __html: t('LC_05_17.msg003') }} />
      </div>
    </div>
    // <div className="tutorial_notes">
    //   <div className="area6">
    //     <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_01.svg` } alt="" />
    //     <p className="tutor_txt" dangerouslySetInnerHTML={ { __html : t( 'LC_05_17.msg003' ) } } />
    //   </div>
    // </div>
  );

};

export default Tip;
